import React, { useEffect, useRef, useState } from 'react';
import { Form, useFormikContext } from 'formik';
import PropTypes from 'prop-types';

import Field from 'core/components/form/form.v2';
import withDatePicker from 'core/components/with-date-picker';
import { useStore } from 'core/store';
import { personalDetailsCodes } from '../quote-forms/quote-forms.constants';
import { Collapsible } from '../collapsible';
import { ErrorAlert } from '../quote-errors';
import { MoreInfoNeededFlagItem } from '../add-info-flag-item';

const PersonalDetails = ({ sectionsToShow }) => {
  const {
    quote: { getAlerts }
  } = useStore();

  const personalDetailsErrors = useRef(null);
  const [shouldShow, setShouldShow] = useState(false);

  const { values, isSubmitting, errors } = useFormikContext();

  const alerts = getAlerts(personalDetailsCodes, values.policyType);

  useEffect(() => {
    if (alerts.length && personalDetailsErrors.current && isSubmitting) {
      personalDetailsErrors.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }, [alerts, isSubmitting]);

  const formikErrors = errors && (errors.driversLicenseNumber || errors.driversLicenseState);
  const forceOpen = formikErrors || alerts.length > 0;

  useEffect(() => {
    if (formikErrors) {
      setShouldShow(true);
    }
    if (sectionsToShow && sectionsToShow?.length > 0) {
      const shouldBeShown = personalDetailsCodes.every((element) => sectionsToShow.includes(element));
      setShouldShow(shouldBeShown);
    }
  }, [sectionsToShow, errors, formikErrors]);

  return (
    <Form>
      {formikErrors && <MoreInfoNeededFlagItem />}
      {alerts.length > 0 && (
        <ErrorAlert errors={alerts} ref={personalDetailsErrors} id="error-alert-personal-details" />
      )}
      {shouldShow && (
        <Collapsible title="Personal Details" forceOpen={forceOpen} initialOpen={alerts.length > 0}>
          <Field
            xs={4}
            type="state"
            id="driversLicenseState"
            name="driversLicenseState"
            mode="light"
            label="Drivers License State"
          />
          <Field
            xs={8}
            type="string"
            id="driversLicenseNumber"
            name="driversLicenseNumber"
            mode="light"
            label="Drivers License Number"
            pii
          />
          <Field
            xs={4}
            type="date"
            id="dateOfBirth"
            name="dateOfBirth"
            mode="light"
            label="Date of birth"
            defaultToEmpty
            pii
          />
        </Collapsible>
      )}
    </Form>
  );
};

PersonalDetails.propTypes = {
  sectionsToShow: PropTypes.array.isRequired,
  showFormikErrorCallout: PropTypes.bool.isRequired
};

export default withDatePicker(PersonalDetails);
